import { Grid } from '@mui/material';
import { ArrowDown, ArrowUp } from '@tassat/icon';
import * as React from 'react';

import muiStyles from './styles';
import { SortMenuItemProps } from './types';

export default function SortMenuItem(props: SortMenuItemProps) {
    const {
        option,
        currentModel
    } = props;

    const {
        title,
        icon
    } = muiStyles(props);

    const sortIcon = React.useMemo(() => {
        if (!currentModel || !option) {
            return null;
        }

        if (currentModel.colId === option.colId) {
            return currentModel.sort === 'asc' ?
                <ArrowUp />
                : <ArrowDown />;
        }

        return null;
    }, [ currentModel, option ]);

    return (
        <Grid
            container
            justifyContent='space-between'
        >
            <Grid
                className={title}
                item
            >
                {option.title}
            </Grid>
            <Grid
                className={icon}
                item
            >
                {sortIcon}
            </Grid>
        </Grid>
    );
}